import { Avatar, Button, Grid, Typography } from "@mui/material";
import { Widget } from "../../utils/helper";

interface Props {
  message: any;
  buttons?: Widget[];
}

function BotChat(props: Props) {
  const { message, buttons } = props;

  return (
    <div
      style={{
        display: "flex",
        margin: "10px",
        gap: "5px",
        flexDirection: "row",
        paddingTop: "10px",
      }}
    >
      <Avatar
        style={{
          height: "30px",
          width: "30px",
          alignSelf: "flex-end",
        }}
        alt="Remy Sharp"
        src="/RIVA_new.png"
      />

      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography
          style={{
            backgroundColor: "rgb(221, 226, 235)",
            maxWidth: "65%",
            padding: 15,
            borderRadius: "8px",
            color: "black",
            marginBottom: 10,
            wordWrap:"break-word"
          }}
        >
          {message}
        </Typography>
        <Grid container spacing={2}>
          {buttons?.map((button: Widget) => (
            <Grid item xs={button?.type === "policy" ? 6 : 4} key={button?.id}>
              <Button
                fullWidth
                onClick={button?.onClick}
                variant="contained"
                title={button?.id}
                disabled={button?.disable}
                style={{
                  textTransform: "none",
                  backgroundColor: button?.disable ? "gray" : "rgb(26, 32, 44)",
                  color: "white",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  display: "block",
                  textOverflow: "ellipsis",
                }}
              >
                {button?.name}
              </Button>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}

export default BotChat;
